import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';
import axios from 'axios';
import {
    CSRF_HEADER_NAME,
    readCsrfToken,
    requiresCsrfToken
} from '../utils/session-cookie.util';

@Injectable({
    providedIn: 'root'
})
export abstract class AxiosAuthenticationService<
    R extends Resource = Resource
> extends Service<R> {
    constructor() {
        super();

        /*
         * ngx-jsonapi talks to the API through axios rather than HttpClient, so the
         * cookie opt in has to be repeated here. No Authorization header is set: the
         * session JWT lives in an HttpOnly cookie that this code cannot read, and
         * withCredentials is what makes the browser attach it. The CSRF token is read
         * per request so it always reflects the current session.
         */
        axios.interceptors.request.use((request) => {
            request.withCredentials = true;

            const csrfToken = readCsrfToken();
            if (csrfToken && requiresCsrfToken(request.method)) {
                request.headers.set(CSRF_HEADER_NAME, csrfToken);
            }

            return request;
        });
    }
}
